export default __webpack_public_path__ + "static/media/padel-silver-thumbnail.3402eb1d.png";